import React, { useState } from 'react';
import { Lock, Smartphone, Ticket, X, ArrowRight, Loader2 } from 'lucide-react';
import { api, guestToken } from '../lib/api';

export default function Gate({ setScreen, setUserAuthed }) {
  const [mode, setMode] = useState('totp');
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr('');
    if (mode === 'totp' && !/^\d{6}$/.test(code.trim())) {
      setErr('Le code authenticator fait 6 chiffres.');
      return;
    }
    setBusy(true);
    try {
      const payload = mode === 'totp' ? { totp_code: code.trim() } : { coupon: code.trim() };
      const { token } = await api.post('/api/session', payload);
      guestToken.set(token);
      setUserAuthed(true);
      setScreen('chat');
    } catch (e) {
      setErr(e.message || "Impossible de vérifier le code. Réessayez.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page narrow center-col">
      <div className="gate-card">
        <div className="gate-ico"><Lock size={22} /></div>
        <h2 className="gate-h">Accès réservé</h2>
        <p className="gate-p">Oliv'IA est privé. Identifiez-vous avec votre application authenticator, ou avec un coupon provisoire fourni par l'administrateur.</p>

        <div className="seg full">
          <button className={`seg-btn${mode === 'totp' ? ' active' : ''}`} onClick={() => { setMode('totp'); setCode(''); setErr(''); }}>
            <Smartphone size={15} /> Authenticator
          </button>
          <button className={`seg-btn${mode === 'coupon' ? ' active' : ''}`} onClick={() => { setMode('coupon'); setCode(''); setErr(''); }}>
            <Ticket size={15} /> Coupon
          </button>
        </div>

        <input
          className="gate-input"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          placeholder={mode === 'totp' ? 'Code à 6 chiffres' : 'OLIV-XXXX'}
          inputMode={mode === 'totp' ? 'numeric' : 'text'}
          maxLength={mode === 'totp' ? 6 : 12}
          autoFocus
        />
        {err && <div className="gate-err"><X size={14} /> {err}</div>}
        <button className="btn-primary wide" onClick={submit} disabled={busy || !code.trim()}>
          {busy ? <Loader2 size={16} className="spin" /> : <ArrowRight size={16} />} Entrer
        </button>
        <button className="link-btn subtle center" onClick={() => setScreen('landing')}>← Retour</button>
      </div>
    </div>
  );
}
